// client/nodes/grid/editor.ts
import { Size } from "@adornis/buildify/client/globals/enums.js";
import { html } from "lit";
import { HTMLBaseContainerGridTableView } from "../../../db/HTMLBaseContainerGrid.js";
import { boxEditor } from "../box.js";
var editor = ({
  content,
  contentController,
  controllerBaseKeyPath,
  host
}) => {
  const globalColumns = content.value([...controllerBaseKeyPath, "columns"], void 0) ?? 3;
  const desktopColumns = content.value([...controllerBaseKeyPath, "columns"], Size.DESKTOP);
  const tabletColumns = content.value([...controllerBaseKeyPath, "columns"], Size.TABLET);
  const mobileColumns = content.value([...controllerBaseKeyPath, "columns"], Size.MOBILE);
  const highestColumnsCount = [globalColumns, desktopColumns, tabletColumns, mobileColumns].sort((a, b) => b - a).at(0);
  if (!content.columnWidths)
    content.columnWidths = [];
  if (content.columnWidths.length > highestColumnsCount)
    content.columnWidths = content.columnWidths.slice(0, highestColumnsCount);
  for (let i = 0; i < highestColumnsCount; i++) {
    const columnValue = content.columnWidths[i];
    if (columnValue !== void 0)
      continue;
    content.columnWidths[i] = "";
  }
  const countColumns = content.value([...controllerBaseKeyPath, "columns"], contentController.size) ?? content.value([...controllerBaseKeyPath, "columns"], void 0) ?? 3;
  return html`
    <!-- column definitions -->
    <x-flex space="md">
      <x-input
        clearable
        placeholder="Anzahl Spalten"
        type="number"
        ${contentController.field(...controllerBaseKeyPath, "columns")}
        @value-picked=${() => {
    host.requestUpdate();
  }}
      ></x-input>

      <x-infobox> Die Summe der Prozentzahl aller Spaltenbreiten sollte max. 100% betragen </x-infobox>
      ${new Array(countColumns).fill(null).map((width, index) => {
    return html`
          <x-input
            clearable
            placeholder=${`Breite der ${index + 1}. Spalte`}
            ${contentController.field(...controllerBaseKeyPath, "columnWidths", index)}
          ></x-input>
        `;
  })}
      <!-- END: column definitions -->

      <x-checkbox
        .label=${"Horizontal scrollen erlauben, wenn zu viel Inhalt nebeneinander angezeigt wird"}
        ${contentController.field(...controllerBaseKeyPath, "allowHorizontalOverflow")}
      ></x-checkbox>

      <x-infobox>
        Um den Abstand der Kacheln innerhalb des Grids zu verändern, kannst du den Wert für den vertikalen oder den
        horizontalen Abstand vergrößern und verkleinern.
      </x-infobox>

      <x-buildify-spacing-picker
        clearable
        select
        placeholder="Abstand zwischen den Spalten"
        ${contentController.field(...controllerBaseKeyPath, "gridColumnGap")}
        select
      ></x-buildify-spacing-picker>
      <x-buildify-spacing-picker
        clearable
        select
        placeholder="Abstand zwischen den Reihen"
        ${contentController.field(...controllerBaseKeyPath, "gridRowGap")}
        select
      ></x-buildify-spacing-picker>

      <x-checkbox
        .label=${"Anordnung der Items im Grid umdrehen"}
        ${contentController.field(...controllerBaseKeyPath, "revertDirection")}
      ></x-checkbox>

      ${content.tableView ? html`
            <x-infobox> Tabellenoptik </x-infobox>
            <x-checkbox
              .label=${"Horizontale Linien hinzuf\xFCgen"}
              ${contentController.field(...controllerBaseKeyPath, "tableView", "hasHorizontalSeperator")}
            ></x-checkbox>
            <x-checkbox
              .label=${"Vertikale Linien hinzuf\xFCgen"}
              ${contentController.field(...controllerBaseKeyPath, "tableView", "hasVerticalSeperator")}
            ></x-checkbox>
            <x-buildify-spacing-picker
              placeholder="Breite der Linien"
              ${contentController.field(...controllerBaseKeyPath, "tableView", "thickness")}
            ></x-buildify-spacing-picker>
            <x-buildify-color-picker
              placeholder="Farbe der Linien"
              ${contentController.field(...controllerBaseKeyPath, "tableView", "colorSeperators")}
            ></x-buildify-color-picker>
            <x-icon-button
              icon="delete"
              text="Tabellenoptik entfernen"
              @click=${() => {
    content.tableView = null;
    host.requestUpdate();
  }}
            ></x-icon-button>
          ` : html`
            <x-icon-button
              icon="add"
              text="Tabellenoptik hinzufügen"
              @click=${() => {
    content.tableView = new HTMLBaseContainerGridTableView({});
    host.requestUpdate();
  }}
            ></x-icon-button>
          `}
      ${boxEditor({
    content,
    // @ts-expect-error its the same class
    contentController,
    controllerBaseKeyPath,
    host
  })}
    </x-flex>
  `;
};
export {
  editor
};
